import React, { useEffect } from "react";
import { Box, Typography, Container,Grid } from "@mui/material";
import { motion} from "framer-motion";
import Footer from "./Footer";

const Automotivecs2 = () => {
     useEffect(() => {
                window.scrollTo(0, 0); // Scroll to top when component loads
              },[]);
  return (
    <Box  sx={{backgroundColor:"#C4D8E2"}}>

      {/* Hero Section */}
      <Box
        sx={{
          height: "100vh",
          backgroundImage: `url('/image/automotive.jpg')`, // replace with your image
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: 10 },
        }}
      >
        <Box maxWidth="1200px"  p={4} borderRadius={2}>
          <Typography variant="h1" sx={{ color: "white",  fontWeight:"bold" , fontSize: { xs: "28px", md: "70px" }}}>
         
          Accelerating automation for a global automotive components supplier
          </Typography>
        </Box>
      </Box>

      {/* Business Needs Section */}
      <Container sx={{ py: 10 }}>
     



    
       
      </Container>
      <Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mt: 0 }} mb={3}>
          {[
            {
              bgImage: "/image/f3.jpeg", // Replace with actual image path
              points: [
                "It is an integrative and enabling solution for the automation of 5G intralogistics management that increases the flexibility, efficiency and traceability of internal logistics processes in Industry 4.0.",
                "Through a scalable platform based on 5G, the sustainable incorporation of different types of mobile autonomous devices is managed.",
              
              ],
            },
            {
              bgImage: "/image/f2.jpeg", // Replace with actual image path
              points: [
                "The technology provided by Telefónica and Tech Informatic Solutions facilitates the incorporation and management of mobile robots, thus enabling flexible automation of internal logistics processes and giving the end user full visibility and control of the operation.",
              ],
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <motion.div
                whileHover={{ y: -5 }} // Jump effect on hover
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
              >
                 <Box
                  sx={{
                    position: "relative",
                    backgroundImage: `url(${feature.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "12px",
                    p: 4,
                    minHeight: "250px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between", // ✅ Ensures equal spacing
                    overflow: "hidden",
                    textAlign: "left", // ✅ Left-aligned text
                  }}
                >
                  {/* Dark Overlay for Better Visibility */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                      zIndex: 1,
                    }}
                  />

                  {/* Bullet Points - Always Visible */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px", // ✅ Creates space between two bullet points
                      minHeight: "100%", // ✅ Ensures equal height
                      mt:6,
                    }}
                  >
                    {feature.points.map((point, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start", // ✅ Aligns bullet with text properly
                          gap: "8px",
                          color: "white",
                          minHeight: "50px", // ✅ Ensures each bullet aligns properly
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "1.5rem",
                            lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                          }}
                        >
                          ✅
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1rem", md: "1.2rem" },
                            lineHeight: "1.5rem", // ✅ Ensures text stays in line
                          }}
                        >
                          {point}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>


      <Container sx={{ py: 10 }}>
      
       
     
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Telefónica and Tech Informatic Solutions are executing a proof of concept (PoC) with CIE Automotive, a global automotive supplier. At its facilities in Itziar (Guipúzcoa), a 5G intralogistics management platform has been developed and is being implemented as an integrating and enabling solution for the automation of the transport of finished products from the end of the production line to the warehouse.
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        Tech Informatic Solutions's Hybrid Infrastructure Managed Services operates the day-to-day operations of the enterprise compute landscape as a private cloud enabled by VMware technology delivering services from different facilities.

        </Typography>
       
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        The objective of the solution is to increase the flexibility, efficiency and traceability of internal logistics processes through the intelligent management of multiple sensors and mobile devices, such as AGVs (automated guided vehicles) and AMRs (autonomous mobile robots).
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        The solution is designed for customers in various industrial segments such as automotive, manufacturing, distribution centers and ports, among others, to gain capacity in the automation of their production processes.”
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        The technology provided by Telefónica and Tech Informatic Solutions facilitates the incorporation and management of mobile robots, providing a scalable platform that helps to improve internal logistics processes, thanks to the sustainable incorporation of different types of mobile autonomous devices, integrating them into the management systems and other sensors of an industrial plant, and providing the user with visibility and control of all operations in real time via 5G, a key element due to the large volume of information, the density of devices, the large coverage required by this type of space and the immediacy required by the entire intralogistics ecosystem. </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Tech Informatic Solutions contributes with its portfolio of technology solutions applied to supply chain and manufacturing, considering the use of digitisation capabilities, analytics and business management solutions, such as SAP, to integrate, centralise and process information from the production process and the AGV navigation system.</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        For its part, Telefónica, through its Telefónica Tech and Telefónica Empresas subsidiaries, provides its Industry 4.0 capabilities, connectivity and partner ecosystem to develop a scalable solution that integrates 5G-enabled operational process automation capabilities. It relies on its partner DTA, a leading provider of industrial mobility technology, to offer AMR devices that can be integrated into the intralogistics platform and are enabled to communicate via 5G.</Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={8}>
        The technology provided by Telefónica and Tech Informatic Solutions facilitates the incorporation and management of mobile robots, thus enabling flexible automation of internal logistics processes and giving the end user full visibility and control of the operation. The platform has the ability to integrate with factory systems and signals and intelligently manage orders for optimal orchestration of autonomous mobile robots of multiple brands and types.  </Typography>

</Container>



<Footer/>
    </Box>


  );
};

export default Automotivecs2;
